import { AsyncActionStatus } from '@app/shared/utils';
import { PetOwner } from '@app/core/models/pet-owner';
import { Consultation, Patient, RenalDetectRecommendation } from '@app/core/models';
import { NextVisitData } from '@app/core/models/visit-next';

/**
 * State for all data shared between tools during a consultation
 */
export interface ConsultationState {
  patient: Patient | null;
  petOwner: PetOwner | null;
  renalDetectRecommendation: RenalDetectRecommendation | null;
  lastConsultation: Consultation | null;
  creatingCurrentConsultation: boolean;
  currentConsultation: Consultation | null;
  currentConsultationVisitDate: Date | null;
  skipProductBook: boolean;
  expectedNextVisit: NextVisitData | null;
  vetSourceOrderStatus: AsyncActionStatus;
  isWLPEligible: boolean;
  isWLPIncluded: boolean;
}

export const initialConsultationState: ConsultationState = {
  patient: null,
  petOwner: null,
  renalDetectRecommendation: null,
  lastConsultation: null,
  creatingCurrentConsultation: false,
  currentConsultation: null,
  currentConsultationVisitDate: null,
  skipProductBook: false,
  expectedNextVisit: null,
  vetSourceOrderStatus: 'NONE',
  isWLPEligible: null,
  isWLPIncluded: null,
};
